// src/modules/estudiante/EstudianteCard.jsx
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DeleteIcon, EditIcon } from "../../assets/icons/Svgs";
import { eliminarEstudiante } from "../../services/estudiante.service";
import {
  showDeletedAlert,
  showErrorAlert,
  showQuestionDeleteAlert,
  showUpdateAlert,
  showAlertDescongelar,
} from "../../components/molecules/ShowAlert";
import { obtenerCodigoRegion } from "../../utils/codigoRegionHelper";

export const EstudianteCard = ({ estudiante, index, onDelete }) => {
  const navigate = useNavigate();
  const [codigoRegion, setCodigoRegion] = useState("N/A");

  const {
    estudiante: datosEst = {},
    persona = {},
    usuario = {},
    registro = {},
    departamento = {},
  } = estudiante || {};

  // Obtener código de región correcto (puede ser async)
  useEffect(() => {
    const calcularCodigo = async () => {
      const codigo = obtenerCodigoRegion(persona, departamento, estudiante?.paisesCache);
      // Si es una Promise, resolverla
      if (codigo instanceof Promise) {
        const resultado = await codigo;
        setCodigoRegion(resultado || "N/A");
      } else {
        setCodigoRegion(codigo || "N/A");
      }
    };
    calcularCodigo();
  }, [persona, departamento, estudiante?.paisesCache]);


  const tipoCongelacion = datosEst?.tipoCongelacion?.trim()?.toLowerCase();
  const estaCongelado =
    tipoCongelacion === "voluntario" ||
    tipoCongelacion === "institucional";

  const tipoAdmision = datosEst?.tipoAdmision || "N/A";

  const handleDelete = async () => {
    showQuestionDeleteAlert({
      callback: async (result) => {
        if (result.isConfirmed) {
          try {
            await eliminarEstudiante(datosEst?.idEstudiante);
            showDeletedAlert({
              callback: () => onDelete?.(datosEst?.idEstudiante),
            });
          } catch (error) {
            console.error("Error al eliminar el estudiante:", error);
            showErrorAlert({});
          }
        }
      },
    });
  };

  const handleUpdate = () => {
    showUpdateAlert({
      callback: () => {
        navigate(`/estudiantes/actualizar/${datosEst?.idEstudiante}`);
      },
    });
  };

  return (
    <tr className="bg-white hover:bg-gray-100 transition-colors duration-300 [&>td]:p-3 [&>td]:text-gray-700 [&>td]:align-middle">
      <td className="font-medium border-r border-slate-200 border-t w-16 whitespace-nowrap">
        {index + 1}
      </td>
      <td className="border-r border-slate-200 border-t w-32 truncate">
        {persona?.nombre}
      </td>
      <td className="border-r border-slate-200 border-t w-32 truncate">
        {persona?.apellido}
      </td>
      <td className="border-r border-slate-200 border-t w-28 truncate">
        {usuario?.username}
      </td>
      <td className="border-r border-slate-200 border-t w-32 truncate">
        {codigoRegion}
      </td>
      <td className="border-r border-slate-200 border-t w-28 truncate">
        {persona?.celular}
      </td>
      <td className="border-r border-slate-200 border-t w-32 truncate">
        {tipoAdmision}
      </td>
      <td className="border-r border-slate-200 border-t w-64 whitespace-nowrap">
        {registro?.grupo?.nombre || "N/A"}
      </td>
      <td className="border-r border-slate-200 border-t w-24 truncate">
        {persona?.sexo}
      </td>
      {/* crédito resaltado si Regular (igual a tu EstudianteGrupoCard) */}
      <td className="border-r border-slate-200 border-t text-center w-24 whitespace-nowrap">
        {tipoAdmision === "Regular" ? (
          <span className="inline-block bg-blue-100 text-blue-800 font-semibold px-3 py-1 rounded-md">
            {datosEst?.credito ?? "No asignado"}
          </span>
        ) : (
          datosEst?.credito ?? "No asignado"
        )}
      </td>
      {/* — aquí le añadimos border-r para mantener la línea vertical — */}
      <td className="border-r border-slate-200 border-t w-auto whitespace-nowrap">
        <div className="flex justify-start gap-4">
          <button
            onClick={() => {
              if (estaCongelado) {
                showAlertDescongelar({
                  icon: "warning",
                  text: `No puedes asignar módulo al estudiante ${persona?.nombre} ${persona?.apellido} mientras esté congelado. Debes descongelarlo.`,
                });
                return;
              }
              navigate(`/asignar-modulo/${datosEst?.idEstudiante}`, {
                state: { estudiante },
              });
            }}
            className={`font-semibold transition-colors py-1 px-4 rounded-lg shadow-md ${
              estaCongelado
                ? "bg-gray-400 cursor-not-allowed text-white"
                : "bg-theme-yellow hover:bg-yellow-500 text-white"
            }`}
          >
            Asignar módulo
          </button>

          <button
            onClick={handleUpdate}
            className="bg-green-500 p-1 rounded-md text-white"
          >
            <EditIcon className="w-5 h-5" />
          </button>

          <button
            onClick={handleDelete}
            className="bg-red-500 p-1 rounded-md text-white"
          >
            <DeleteIcon className="w-5 h-5" />
          </button>
        </div>
      </td>
    </tr>
  );
};
